import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { callApi } from "../../../lib/apiCaller"; // adjust the import if needed
import { track } from "./trackSlice";
import { APP_VERSION } from "../../constants";
import { getClientLocation } from "../../utils/clientLocation";

export const getOtp = createAsyncThunk(
  "auth/getOtp",
  async (phone, ThunkAPI) => {
    try {
      const res = await callApi({
        key: "REQUEST_OTP",
        method: "POST",
        body: { mobile: phone },
      });

      return res.data;
    } catch (error) {
      return ThunkAPI.rejectWithValue(
        error?.message || "Failed to request OTP",
      );
    }
  },
);
export const trackExistingUser = createAsyncThunk(
  "auth/trackExistingUser",
  async (_, ThunkAPI) => {
    try {
      const state = ThunkAPI.getState();
      const mobile = state.auth.mobile;
      if (!mobile) return; // No mobile, skip

      const locationData = await getClientLocation();
      const adresss = JSON.parse(
        localStorage.getItem("selectedAddress") || "{}",
      );
      const trackState = state.track;
      const payload = {
        mobileNumber: mobile,
        platform: "web",
        appVersion: APP_VERSION,
        userAgent:
          typeof window !== "undefined" ? window.navigator.userAgent : "",
        country: trackState.country || locationData.country || "India",
        ipAddress: locationData.ipAddress,
        city: adresss?.city || "Gurugram",
      };
      ThunkAPI.dispatch(track(payload));
    } catch (error) {
      // Silent fail for tracking
      console.error("Failed to track existing user:", error);
    }
  },
);
export const loginWithOtp = createAsyncThunk(
  "auth/loginWithOtp",
  async ({ phone, otp, lastSource }, ThunkAPI) => {
    try {
      const res = await callApi({
        key: "CUSTOMER_LOGIN",
        method: "POST",
        body: { mobile: phone, otp, lastSource },
      });
      // After successful login, dispatch track
      const locationData = await getClientLocation();
      const adresss = JSON.parse(
        localStorage.getItem("selectedAddress") || "{}",
      );
      const state = ThunkAPI.getState();
      const trackState = state.track;
      const payload = {
        mobileNumber: phone,
        platform: "web",
        appVersion: APP_VERSION,
        userAgent:
          typeof window !== "undefined" ? window.navigator.userAgent : "",
        country: trackState.country || locationData.country || "India",
        ipAddress: locationData.ipAddress,
        city: adresss?.city || "Gurugram",
      };
      ThunkAPI.dispatch(track(payload));
      return res?.data; // usually returns { token, user }
    } catch (error) {
      return ThunkAPI.rejectWithValue(error?.message || "Login failed");
    }
  },
);
export const updateCustomerProfile = createAsyncThunk(
  "auth/updateCustomerProfile",
  async (profileData, ThunkAPI) => {
    try {
      const token = ThunkAPI.getState().auth.token;
      if (!token) return ThunkAPI.rejectWithValue("No auth token found");

      const res = await callApi({
        key: "UPDATE_CUSTOMER_PROFILE",
        method: "PUT",
        body: profileData,
        auth: true,
      });
      // Track is only called on login, not on profile update
      return res.data;
    } catch (error) {
      return ThunkAPI.rejectWithValue(
        error?.message || "Failed to update profile",
      );
    }
  },
);
export const fetchCustomerProfile = createAsyncThunk(
  "auth/fetchCustomerProfile",
  async (_, ThunkAPI) => {
    try {
      const state = ThunkAPI.getState().auth;
      const token = state.token;

      if (!token) return ThunkAPI.rejectWithValue("No auth token found");

      const res = await callApi({
        key: "FETCH_CUSTOMER_PROFILE",
        method: "POST",
        auth: true,
      });

      return res?.data;
    } catch (error) {
      return ThunkAPI.rejectWithValue(
        error?.message || "Failed to fetch profile",
      );
    }
  },
);
export const fetchSlots = createAsyncThunk(
  "/slots/upcoming",
  async ({ city, serviceTypeId }, ThunkAPI) => {
    try {
      const res = await callApi({
        key: "NEW_UPCOMING_SLOT",
        method: "POST",
        body: {
          serviceId: "507f1f77bcf86cd799439011",
          areaId: "507f1f77bcf86cd799439012",
          days: 7,
        },
        // auth: true,
        useContent: true,
      });

      return res.data;
    } catch (error) {
      return ThunkAPI.rejectWithValue(
        error?.message || "Failed to fetch slots",
      );
    }
  },
);
const authAndAddressSlice = createSlice({
  name: "authAndAddress",
  initialState: {
    token: typeof window !== "undefined" ? localStorage.getItem("token") : null,
    mobile:
      typeof window !== "undefined" ? localStorage.getItem("mobile") : null,
    user:
      typeof window !== "undefined"
        ? JSON.parse(localStorage.getItem("profile"))
        : null,
    slots: [],
    Userprofile:
      typeof window !== "undefined"
        ? JSON.parse(localStorage.getItem("profile"))
        : null,
    loading: false,
    error: null,
    isProfileFetching: false,
    isLoginInProgress: false,
    profileFetchBlocked: false,
  },
  reducers: {
    setToken: (state, action) => {
      state.token = action.payload;
    },
    clearAuth: (state) => {
      state.token = null;
      state.user = null;
      state.Userprofile = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Handle getOtp
      .addCase(getOtp.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getOtp.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(getOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Handle loginWithOtp
      .addCase(loginWithOtp.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.isLoginInProgress = true;
        state.profileFetchBlocked = true;
      })
      .addCase(loginWithOtp.fulfilled, (state, action) => {
        state.loading = false;
        state.isLoginInProgress = false;
        state.profileFetchBlocked = false;
        state.token = action.payload.value.token; // ✅ correct path
        state.mobile = action.payload.value.mobile;
        localStorage.setItem("token", action.payload.value.token);
        localStorage.setItem("mobile", action.payload.value.mobile);
        // Set flag to prevent duplicate tracking
        localStorage.setItem("justLoggedIn", "true");
      })

      .addCase(loginWithOtp.rejected, (state, action) => {
        state.loading = false;
        state.isLoginInProgress = false;
        state.profileFetchBlocked = false;
        state.error = action.payload;
      })

      // Update profile
      .addCase(updateCustomerProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCustomerProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.Userprofile = action.payload.value;
        state.user = action.payload.value;
        localStorage.setItem("profile", JSON.stringify(action.payload.value));
      })
      .addCase(updateCustomerProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchCustomerProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.isProfileFetching = true;
      })
      .addCase(fetchCustomerProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.isProfileFetching = false;
        state.Userprofile = action.payload.value;
        // Store profile data in localStorage for persistence
        localStorage.setItem("profile", JSON.stringify(action.payload.value));
      })
      .addCase(fetchCustomerProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.isProfileFetching = false;
      })

      //slots
      .addCase(fetchSlots.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSlots.fulfilled, (state, action) => {
        state.loading = false;
        // Store raw slot data to preserve new format structure
        const rawSlots = action.payload.value || action.payload;
        // console.log("=== REDUX SLOT DATA ===");
        // console.log("Full API response:", action.payload);
        // console.log("Extracted slots:", rawSlots);
        // console.log(
        //   "Slots count:",
        //   Array.isArray(rawSlots) ? rawSlots.length : "Not an array"
        // );
        // console.log("=======================");
        state.slots = rawSlots;
      })
      .addCase(fetchSlots.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export const { setToken, clearAuth } = authAndAddressSlice.actions;
export default authAndAddressSlice.reducer;
